import mfpi_ids from '../../plugins/ids/node.jsy'
import mfpi_net from '../../plugins/net/index.jsy'

import FabricHub from './mf-json.jsy'
export default FabricHub.plugin(mfpi_ids(), mfpi_net())

